import React from 'react';

export default function ArenaHeader() {
  return (
    <div>
      <div className="text-forge-label mb-1">Partner Competition</div>
      <h1 className="text-2xl font-black tracking-wide text-foreground">THE FORGE ARENA</h1>
      <p className="text-sm text-muted-foreground mt-1">Execution is the only scoreboard.</p>
    </div>
  );
}